const YellowHandIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 233.6 283.65" width="35" height="35">
            <g>
                <path
                    d="M178.8,213.19v37.25c0,15.45-7.61,31.95-23.08,31.95H89.47c-3.52,0-6.88-2.63-10-3.84L63.32,261.42,8.09,205.71C-.14,197.45-1.22,183.79,6.43,175a21.86,21.86,0,0,1,32.06-1.35l15.56,18.17c1.77,1.77,2.15.47,2.15.39V87.38c0-14.5,12.48-24.32,24.59-24.32a21.87,21.87,0,0,1,15.49,6.41c4,4,6.43,9.43,6.43,17.9v77.21l8.67.6,51.9,22.15c10.49,4.32,15.52,14.53,15.52,25.86Z"
                    fill="#efcbbd"
                    stroke="#231f20"
                    strokeWidth="2.52"
                    strokeMiterlimit="10"
                />
                <path
                    d="M145,27.13V97.51c0,16.35-12.71,34.8-29.07,34.8H102.7V85c0-6-1.73-11.53-5.68-15.48s-10.75-6.42-16.8-6.42c-12.12,0-24,9.82-24,21.9v47.36h-10C29.84,132.32,16,113.87,16,97.51V27.13C16,10.8,29.84,1.26,46.19,1.26h69.73C132.27,1.26,145,10.8,145,27.13Z"
                    fill="#f7db34"
                    stroke="#231f20"
                    strokeWidth="2.52"
                    strokeMiterlimit="10"
                />
                <path
                    d="M232.34,122v37.85c0,8.79-7.75,20.2-16.54,20.2H178.3c-8.79,0-16.21-11.41-16.21-20.2V122c0-8.78,7.42-15.39,16.21-15.39h37.5C224.59,106.59,232.34,113.2,232.34,122Z"
                    fill="#ffefab"
                    stroke="#231f20"
                    strokeWidth="2.52"
                    strokeMiterlimit="10"
                />
                <path
                    d="M230.32,33.4V71.25c0,8.79-7.74,20.2-16.54,20.2H176.29c-8.8,0-16.21-11.41-16.21-20.2V33.4c0-8.78,7.41-15.39,16.21-15.39h37.49C222.58,18,230.32,24.62,230.32,33.4Z"
                    fill="#f9e68a"
                    stroke="#231f20"
                    strokeWidth="2.52"
                    strokeMiterlimit="10"
                />
            </g>
        </svg>
    );
};

export default YellowHandIcon;
